import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import HijriCalender from "../../pages/user/user-settings/hijri-calender";
import AiSiteBuilder from "../../pages/ai-site-builder/AiSiteBuilder";
import UserInvoiceView from "../../pages/user/user-invoices/user-invoice-view";
import UserProfileView from "../../pages/user/user-profile/user-profile-view";
import UserInvoiceTable from "../../pages/user/user-invoices/user-invoice-table";
import PrayerTimeMain from "../../pages/user/prayer-time/prayer-time-main";
import PrayerTimeType from "../../pages/user/prayer-time/prayer-times-type";
import PrayerTimeAthan from "../../pages/user/prayer-time/prayer-times-athan";
import PrayerTimeAthanCalculation from "../../pages/user/prayer-time/prayer-times-athan-calculation";
import PrayerTimeAthanImport from "../../pages/user/prayer-time/prayer-times-athan-import";
import PrayerTimeIqamah from "../../pages/user/prayer-time/prayer-times-iqamah";
import PrayerTimeIqamahCalculation from "../../pages/user/prayer-time/prayer-times-iqamah-calculation";
import PrayerTimeIqamahImport from "../../pages/user/prayer-time/prayer-times-iqamah-import";
import InvoicePDF from "../../pages/user/user-invoices/InvoicePDF";
import ProtectedRoute from "../PrivateRoute";
import UserAnnouncements from "../../pages/user/user-announcements/user-announcements";
import UserNews from "../../pages/user/user-news/user-news";
import UserEvents from "../../pages/user/user-events/user-events";
import UserNotifications from "../../pages/user/user-dashboard/user-notifications";
import UserTeam from "../../pages/user/user-team/user-team";
import PrayerTimeJummah from "../../pages/user/prayer-time/prayer-time-jummah";
import Resources from "../../pages/user/user-resources/user-resources";
import ResourcesMediaManagement from "../../pages/user/user-resources/user-media-assets";
import DonationsDashboard from "../../pages/user/user-dontations/user-dontations";
import MasjidApp from "../../pages/user/user-masjid-app/user-masjid-app";
import PrayerTimeSpecial from "../../pages/user/prayer-time/special-prayertime";
import UserSettingMain from "../../pages/user/user-settings/user-setting-main";
import Subscription from "../../pages/user/user-subscription/subscription";
import MasjidWeb from "../../pages/user/user-masjidWeb/user-masjidWeb";
import MasjidDisplay from "../../pages/user/user-masjidDisplay/user-masjidDisplay";
import TemplateRender from "../../pages/template-render/TemplateRender";
import Card from "../../pages/user/stripe-card/Card";


// Lazy load user pages
const Dashboard = lazy(() => import("../../pages/user/user-dashboard/user-dashboard"));
const DashboardStats = lazy(() => import("../../pages/user/user-dashboard/user-dashboardStats"));
const GeneralSettings = lazy(() => import("../../pages/user/user-settings/general-setttings"));
const MasjidInformation = lazy(() => import("../../pages/user/user-settings/masjid-information"));
const support = () => import("../../pages/user/user-support/user-support");
const UserSupport = lazy(() => support().then((m) => ({ default: m.UserSupport })));
const UserTicket = lazy(() => support().then((m) => ({ default: m.UserTicket })));
const UserMessages = lazy(() => import("../../pages/user/user-messages/user-messages").then((m) => ({ default: m.UserMessages })));

const userRoutes = [
  <Route
    path="/user-dashboard/*"
    element={
      <ProtectedRoute requiredPermission={[1, 2]}>
        <Dashboard />
      </ProtectedRoute>
    }
    key="dashboard"
  >
    <Route index element={<DashboardStats />} />
    <Route path="user-notifications" element={<UserNotifications />} />
    <Route path="general-settings" element={<GeneralSettings />} />
    <Route path="masjid-information" element={<MasjidInformation />} />
    <Route path="user-announcements" element={<UserAnnouncements />} />
    <Route path="user-news" element={<UserNews />} />
    <Route path="user-events" element={<UserEvents />} />
    {/* Templates are hidden for now: every website is built from a prompt.
        The template pages (Template-Selection, website-editor) are kept for
        removal later; their old links land on the AI builder. */}
    <Route path="template" element={<Navigate to="/user-dashboard/ai-site" replace />} />
    <Route path="template/:templateId" element={<Navigate to="/user-dashboard/ai-site" replace />} />
    <Route path="ai-site" element={<AiSiteBuilder />} />
    <Route path="hijri-calendar" element={<HijriCalender />} />
    <Route path="masjid-web" element={<MasjidWeb />} />
    <Route path="masjid-display" element={<MasjidDisplay />} />

    {/* teams */}
    <Route path="team" element={<UserTeam />} />

    {/* settings */}
    <Route path="user-settings" element={<UserSettingMain />} />

    {/* subscription */}
    <Route path="subscription" element={<Subscription />} />
    {/* card stripe */}
    <Route path="card" element={<Card />} />


    {/* teams */}
    <Route path="user-donations" element={<DonationsDashboard />} />
    <Route path="masjid-app" element={<MasjidApp />} />
    <Route path="support" element={<UserSupport />} />
    <Route path="support/:id" element={<UserTicket />} />
    <Route path="messages" element={<UserMessages />} />

    {/* Resources */}
    <Route path="resources" element={<Resources />} />
    <Route path="resources-media-management" element={<ResourcesMediaManagement />} />

    {/* prayer-times */}
    <Route path="prayer-times" element={<Navigate to="/user-dashboard/prayer-times/main" replace />} />
    <Route path="prayer-times/main" element={<PrayerTimeMain />} />
    <Route path="prayer-times/type" element={<PrayerTimeType />} />
    <Route path="prayer-times/jummah" element={<PrayerTimeJummah />} />
    <Route path="prayer-times/Special" element={<PrayerTimeSpecial />} />


    {/* prayer-times-athan */}
    <Route path="prayer-times/athan" element={<PrayerTimeAthan />} />
    <Route path="prayer-times/athan/calculation" element={<PrayerTimeAthanCalculation />} />
    <Route path="prayer-times/athan/mehtod" element={<Navigate to="/user-dashboard/prayer-times/athan/calculation" replace />} />
    <Route path="prayer-times/athan/import" element={<PrayerTimeAthanImport />} />

    {/* prayer-times-iqamah */}
    <Route path="prayer-times/iqamah" element={<PrayerTimeIqamah />} />
    <Route path="prayer-times/iqamah/calculation" element={<PrayerTimeIqamahCalculation />} />
    <Route path="prayer-times/iqamah/mehtod" element={<Navigate to="/user-dashboard/prayer-times/iqamah/calculation" replace />} />
    <Route path="prayer-times/iqamah/import" element={<PrayerTimeIqamahImport />} />

    {/* invoices */}
    <Route path="invoices" element={<UserInvoiceTable />} />
    <Route path="invoice/:invoiceId" element={<UserInvoiceView />} />
    <Route path="invoice-pdf" element={<InvoicePDF />} />

    {/* user-profile */}
    <Route path="user-profile" element={<UserProfileView />} />
    <Route path="template-render" element={<TemplateRender />} />


  </Route>
];

export default userRoutes;
